// extracted by mini-css-extract-plugin
module.exports = {"spaceLeft":"ContainerControls-m__spaceLeft___n_iZn"};